import React from 'react';
import { ShapesGallery } from './ShapesGallery';
import { CROP_SHAPE_CATEGORIES, CROP_SHAPE_QUICK, cropShapeLabel } from '../../lib/cropShape';
import { Square } from 'lucide-react';

/**
 * Crop to Shape gallery (Publisher Picture Tools ▸ Crop ▸ Crop to Shape): the Shapes gallery reduced to closed
 * shapes, with quick picks and a "Rectangle (remove shape)" footer. `current` is the picture's cropShape.
 */
export const CropShapeGallery = ({ current, onPick, children, align = 'start', side, testId = 'crop-shape-gallery' }) => (
  <ShapesGallery
    categories={CROP_SHAPE_CATEGORIES}
    quick={CROP_SHAPE_QUICK}
    selected={current || null}
    title={current ? `Crop to Shape — currently ${cropShapeLabel(current)}` : 'Crop to Shape — pick an outline for the picture'}
    onPick={onPick}
    align={align}
    side={side}
    testId={testId}
    footer={(
      <button type="button" onClick={() => onPick(null)} disabled={!current} className="w-full h-8 px-2 rounded-sm text-[12px] flex items-center gap-2 text-foreground hover:bg-primary/10 disabled:opacity-50 disabled:hover:bg-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" data-testid={`${testId}-remove`}>
        <Square className="w-4 h-4 text-muted-foreground" aria-hidden="true" /> Rectangle — remove the crop shape
      </button>
    )}
  >
    {children}
  </ShapesGallery>
);
